import React from "react";
import "./Logo.css";

const Logo = () => {
  return (
    <div className="LogoWrapper">
      <h2>code</h2>
      <div className="LogoIcon">
        <div className="LogoSquare">
          <div className="LogoGlow"></div>
        </div>
        <div className="LogoCircle"></div>
        <div className="LogoLine"></div>
      </div>
      <h2>zephyr</h2>
    </div>
  );
};

export default Logo;
